<template>
  <label class="custom-checkbox">
    <input
      type="checkbox"
      :checked="modelValue"
      @change="$emit('input', $event.target.checked)"
    >
    <span class="checkmark"></span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    value: Boolean,
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
.custom-checkbox {
  border-radius: 4px;
  margin: 0;
  padding: 8px;
  background-color: #fff;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
}

.custom-checkbox input {
  display: none;
}

.checkmark {
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 2px solid #D9D2FF;
  border-radius: 2px;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s;
}

.custom-checkbox input:checked + .checkmark {
  background-color: #1A6A72;
  border-color: #1A6A72;
  /*
  VERSION D2
  border-radius: 50%;
  @media (max-width: 1024px) {
    border-radius: 2px;
  }
   */
}

.checkmark::after {
  content: '';
  position: absolute;
  display: none;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 0.113rem 0.113rem 0;
  transform: rotate(45deg);
}

.custom-checkbox input:checked + .checkmark::after {
  display: block;
}
</style>
